import Modal from "antd/lib/modal/Modal";
import React, { useContext, useState } from "react";
import { Button, DatePicker, Space, Form, notification } from "antd";
import NaocDailyProductionStore from "../store/naocdailyproductionstore";
import { observer } from "mobx-react-lite";
import { ProgressIndicator } from "@fluentui/react";
const { RangePicker } = DatePicker;
export const SummaryAsExcelRpt = observer(() => {
  const naocDailyProductionStore = useContext(NaocDailyProductionStore);
  const [podExportDate, setPodExportDate] = useState(null);
  return (
    <Modal
      visible={naocDailyProductionStore.showPODExportAsExcelDialog}
      title={"OER Unreconciled Consolidated Evacuation Summary Report"}
      onCancel={() => {
        naocDailyProductionStore.showPODExportAsExcelDialog = false;
      }}
      centered
      footer={
        <Space>
          {naocDailyProductionStore.isExporting && (
            <ProgressIndicator
              description="exporting, please wait..."
              styles={{ root: { width: "200px", textAlign: "left" } }}
            />
          )}
          <Button
            type="link"
            onClick={() => {
              naocDailyProductionStore.showPODExportAsExcelDialog = false;
            }}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            loading={naocDailyProductionStore.isExporting}
            disabled={podExportDate === null}
            onClick={async () => {
              try {
                naocDailyProductionStore.exportPodSummary(podExportDate);
              } catch (error) {
                notification.error({
                  message: "SPARS Feedback",
                  description: error.message,
                });
              }
            }}
          >
            Export
          </Button>
        </Space>
      }
    >
      <Form layout="vertical" name="basic">
        <Form.Item>
          <RangePicker
            placeholder={[
              "Refer (Production) Start Date",
              "Refer (Production) End Date",
            ]}
            style={{ width: "95%" }}
            onChange={(dateObj, dateStringArr) => {
              setPodExportDate(dateObj);
            }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
});

